/**
 * Navigation icons — the allow-listed lucide set a menu node may name in its
 * `icon` key, rendered in every layout (menus, tabs, dock tiles, ribbon
 * buttons, breadcrumbs, screen titles).
 *
 * The NAMES are data: `navIcons.json` (also read by the backend
 * `nav_validation` and the builder icon picker). This file only maps each
 * name to its component — explicit named imports so the bundle carries the
 * curated set and nothing else. `test-script/test_nav_icons.py` keeps the two
 * in step.
 */
import type { CSSProperties } from 'react'
import {
  Activity as I_Activity, AlarmClock as I_AlarmClock, AppWindow as I_AppWindow, Archive as I_Archive,
  Armchair as I_Armchair, Award as I_Award, BadgeCheck as I_BadgeCheck, BadgePercent as I_BadgePercent,
  Banknote as I_Banknote, BarChart as I_BarChart, Barcode as I_Barcode, Bath as I_Bath,
  Bed as I_Bed, Bell as I_Bell, BellRing as I_BellRing, Bike as I_Bike,
  Book as I_Book, BookMarked as I_BookMarked, BookOpen as I_BookOpen, BookUser as I_BookUser,
  Bookmark as I_Bookmark, Box as I_Box, Boxes as I_Boxes, Briefcase as I_Briefcase,
  BriefcaseBusiness as I_BriefcaseBusiness, Brush as I_Brush, Bug as I_Bug, Building as I_Building,
  Building2 as I_Building2, Bus as I_Bus, Cake as I_Cake, Calculator as I_Calculator,
  Calendar as I_Calendar, CalendarCheck as I_CalendarCheck, CalendarClock as I_CalendarClock, CalendarDays as I_CalendarDays,
  CalendarRange as I_CalendarRange, Camera as I_Camera, Car as I_Car, ChartBar as I_ChartBar,
  ChartColumn as I_ChartColumn, ChartLine as I_ChartLine, ChartPie as I_ChartPie, CircleDollarSign as I_CircleDollarSign,
  CircleHelp as I_CircleHelp, ClipboardCheck as I_ClipboardCheck, ClipboardList as I_ClipboardList, ClipboardPen as I_ClipboardPen,
  Clock as I_Clock, Clock3 as I_Clock3, Coffee as I_Coffee, Cog as I_Cog,
  Coins as I_Coins, Compass as I_Compass, Construction as I_Construction, Contact as I_Contact,
  Container as I_Container, Cpu as I_Cpu, CreditCard as I_CreditCard, Crown as I_Crown,
  Database as I_Database, Dna as I_Dna, DollarSign as I_DollarSign, Dumbbell as I_Dumbbell,
  Earth as I_Earth, Euro as I_Euro, Eye as I_Eye, Factory as I_Factory,
  FileCheck as I_FileCheck, FileClock as I_FileClock, FileInput as I_FileInput, FileOutput as I_FileOutput,
  FilePlus as I_FilePlus, FileSearch as I_FileSearch, FileSignature as I_FileSignature, FileSpreadsheet as I_FileSpreadsheet,
  FileText as I_FileText, Files as I_Files, Film as I_Film, Fingerprint as I_Fingerprint,
  Flag as I_Flag, FlaskConical as I_FlaskConical, Folder as I_Folder, FolderArchive as I_FolderArchive,
  FolderKanban as I_FolderKanban, FolderOpen as I_FolderOpen, Forklift as I_Forklift, Fuel as I_Fuel,
  Gauge as I_Gauge, Gavel as I_Gavel, Gem as I_Gem, Gift as I_Gift,
  GitBranch as I_GitBranch, Glasses as I_Glasses, Globe as I_Globe, Globe2 as I_Globe2,
  GraduationCap as I_GraduationCap, Hammer as I_Hammer, HandCoins as I_HandCoins, Handshake as I_Handshake,
  HardDrive as I_HardDrive, HardHat as I_HardHat, Headset as I_Headset, HeartPulse as I_HeartPulse,
  History as I_History, Home as I_Home, Hospital as I_Hospital, Hotel as I_Hotel,
  House as I_House, IdCard as I_IdCard, Image as I_Image, Inbox as I_Inbox,
  IndianRupee as I_IndianRupee, Info as I_Info, Kanban as I_Kanban, Key as I_Key,
  KeyRound as I_KeyRound, Landmark as I_Landmark, Languages as I_Languages, Laptop as I_Laptop,
  Layers as I_Layers, LayoutDashboard as I_LayoutDashboard, LayoutGrid as I_LayoutGrid, Leaf as I_Leaf,
  Library as I_Library, LifeBuoy as I_LifeBuoy, Lightbulb as I_Lightbulb, List as I_List,
  ListChecks as I_ListChecks, ListTodo as I_ListTodo, Lock as I_Lock, LockKeyhole as I_LockKeyhole,
  Mail as I_Mail, Mailbox as I_Mailbox, Map as I_Map, MapPin as I_MapPin,
  MapPinned as I_MapPinned, Medal as I_Medal, Megaphone as I_Megaphone, MessageCircle as I_MessageCircle,
  MessageSquare as I_MessageSquare, MessageSquareText as I_MessageSquareText, Mic as I_Mic, Microscope as I_Microscope,
  Monitor as I_Monitor, Music as I_Music, Music2 as I_Music2, Navigation as I_Navigation,
  Network as I_Network, Newspaper as I_Newspaper, NotebookPen as I_NotebookPen, Package as I_Package,
  PackageCheck as I_PackageCheck, PackageOpen as I_PackageOpen, PackagePlus as I_PackagePlus, Palette as I_Palette,
  Paperclip as I_Paperclip, PartyPopper as I_PartyPopper, Percent as I_Percent, Phone as I_Phone,
  PhoneCall as I_PhoneCall, PieChart as I_PieChart, PiggyBank as I_PiggyBank, Pill as I_Pill,
  Plane as I_Plane, PlaneTakeoff as I_PlaneTakeoff, PoundSterling as I_PoundSterling, Printer as I_Printer,
  QrCode as I_QrCode, Radio as I_Radio, Receipt as I_Receipt, ReceiptText as I_ReceiptText,
  Rocket as I_Rocket, Route as I_Route, Scale as I_Scale, ScanLine as I_ScanLine,
  School as I_School, Search as I_Search, Send as I_Send, SendHorizontal as I_SendHorizontal,
  Server as I_Server, Settings as I_Settings, Sheet as I_Sheet, Shield as I_Shield,
  ShieldCheck as I_ShieldCheck, Ship as I_Ship, Shirt as I_Shirt, ShoppingBag as I_ShoppingBag,
  ShoppingBasket as I_ShoppingBasket, ShoppingCart as I_ShoppingCart, Signature as I_Signature, Sliders as I_Sliders,
  Smartphone as I_Smartphone, Sparkles as I_Sparkles, Sprout as I_Sprout, Star as I_Star,
  Stethoscope as I_Stethoscope, StickyNote as I_StickyNote, Store as I_Store, Table as I_Table,
  Tag as I_Tag, Tags as I_Tags, Target as I_Target, Thermometer as I_Thermometer,
  Ticket as I_Ticket, TicketCheck as I_TicketCheck, TicketX as I_TicketX, Timer as I_Timer,
  Tractor as I_Tractor, TrainFront as I_TrainFront, TrendingDown as I_TrendingDown, TrendingUp as I_TrendingUp,
  Trophy as I_Trophy, Truck as I_Truck, Tv as I_Tv, Undo2 as I_Undo2,
  Unlock as I_Unlock, User as I_User, UserCheck as I_UserCheck, UserCog as I_UserCog,
  UserPlus as I_UserPlus, UserRound as I_UserRound, Users as I_Users, UsersRound as I_UsersRound,
  Utensils as I_Utensils, Video as I_Video, Wallet as I_Wallet, Wand2 as I_Wand2,
  WandSparkles as I_WandSparkles, Warehouse as I_Warehouse, Waypoints as I_Waypoints, Wifi as I_Wifi,
  Workflow as I_Workflow, Wrench as I_Wrench, Zap as I_Zap,
  type LucideIcon,
} from 'lucide-react'
import NAV_ICONS_DATA from './navIcons.json'

export interface NavIconGroup { id: string; label: string; icons: string[] }

const DATA = NAV_ICONS_DATA as {
  groups: NavIconGroup[]
  typeFallback: Record<string, string>
  defaultIcon: string
}

const MAP: Record<string, LucideIcon> = {
  'activity': I_Activity,
  'alarm-clock': I_AlarmClock,
  'app-window': I_AppWindow,
  'archive': I_Archive,
  'armchair': I_Armchair,
  'award': I_Award,
  'badge-check': I_BadgeCheck,
  'badge-percent': I_BadgePercent,
  'banknote': I_Banknote,
  'bar-chart': I_BarChart,
  'barcode': I_Barcode,
  'bath': I_Bath,
  'bed': I_Bed,
  'bell': I_Bell,
  'bell-ring': I_BellRing,
  'bike': I_Bike,
  'book': I_Book,
  'book-marked': I_BookMarked,
  'book-open': I_BookOpen,
  'book-user': I_BookUser,
  'bookmark': I_Bookmark,
  'box': I_Box,
  'boxes': I_Boxes,
  'briefcase': I_Briefcase,
  'briefcase-business': I_BriefcaseBusiness,
  'brush': I_Brush,
  'bug': I_Bug,
  'building': I_Building,
  'building-2': I_Building2,
  'bus': I_Bus,
  'cake': I_Cake,
  'calculator': I_Calculator,
  'calendar': I_Calendar,
  'calendar-check': I_CalendarCheck,
  'calendar-clock': I_CalendarClock,
  'calendar-days': I_CalendarDays,
  'calendar-range': I_CalendarRange,
  'camera': I_Camera,
  'car': I_Car,
  'chart-bar': I_ChartBar,
  'chart-column': I_ChartColumn,
  'chart-line': I_ChartLine,
  'chart-pie': I_ChartPie,
  'circle-dollar-sign': I_CircleDollarSign,
  'circle-help': I_CircleHelp,
  'clipboard-check': I_ClipboardCheck,
  'clipboard-list': I_ClipboardList,
  'clipboard-pen': I_ClipboardPen,
  'clock': I_Clock,
  'clock-3': I_Clock3,
  'coffee': I_Coffee,
  'cog': I_Cog,
  'coins': I_Coins,
  'compass': I_Compass,
  'construction': I_Construction,
  'contact': I_Contact,
  'container': I_Container,
  'cpu': I_Cpu,
  'credit-card': I_CreditCard,
  'crown': I_Crown,
  'database': I_Database,
  'dna': I_Dna,
  'dollar-sign': I_DollarSign,
  'dumbbell': I_Dumbbell,
  'earth': I_Earth,
  'euro': I_Euro,
  'eye': I_Eye,
  'factory': I_Factory,
  'file-check': I_FileCheck,
  'file-clock': I_FileClock,
  'file-input': I_FileInput,
  'file-output': I_FileOutput,
  'file-plus': I_FilePlus,
  'file-search': I_FileSearch,
  'file-signature': I_FileSignature,
  'file-spreadsheet': I_FileSpreadsheet,
  'file-text': I_FileText,
  'files': I_Files,
  'film': I_Film,
  'fingerprint': I_Fingerprint,
  'flag': I_Flag,
  'flask-conical': I_FlaskConical,
  'folder': I_Folder,
  'folder-archive': I_FolderArchive,
  'folder-kanban': I_FolderKanban,
  'folder-open': I_FolderOpen,
  'forklift': I_Forklift,
  'fuel': I_Fuel,
  'gauge': I_Gauge,
  'gavel': I_Gavel,
  'gem': I_Gem,
  'gift': I_Gift,
  'git-branch': I_GitBranch,
  'glasses': I_Glasses,
  'globe': I_Globe,
  'globe-2': I_Globe2,
  'graduation-cap': I_GraduationCap,
  'hammer': I_Hammer,
  'hand-coins': I_HandCoins,
  'handshake': I_Handshake,
  'hard-drive': I_HardDrive,
  'hard-hat': I_HardHat,
  'headset': I_Headset,
  'heart-pulse': I_HeartPulse,
  'history': I_History,
  'home': I_Home,
  'hospital': I_Hospital,
  'hotel': I_Hotel,
  'house': I_House,
  'id-card': I_IdCard,
  'image': I_Image,
  'inbox': I_Inbox,
  'indian-rupee': I_IndianRupee,
  'info': I_Info,
  'kanban': I_Kanban,
  'key': I_Key,
  'key-round': I_KeyRound,
  'landmark': I_Landmark,
  'languages': I_Languages,
  'laptop': I_Laptop,
  'layers': I_Layers,
  'layout-dashboard': I_LayoutDashboard,
  'layout-grid': I_LayoutGrid,
  'leaf': I_Leaf,
  'library': I_Library,
  'life-buoy': I_LifeBuoy,
  'lightbulb': I_Lightbulb,
  'list': I_List,
  'list-checks': I_ListChecks,
  'list-todo': I_ListTodo,
  'lock': I_Lock,
  'lock-keyhole': I_LockKeyhole,
  'mail': I_Mail,
  'mailbox': I_Mailbox,
  'map': I_Map,
  'map-pin': I_MapPin,
  'map-pinned': I_MapPinned,
  'medal': I_Medal,
  'megaphone': I_Megaphone,
  'message-circle': I_MessageCircle,
  'message-square': I_MessageSquare,
  'message-square-text': I_MessageSquareText,
  'mic': I_Mic,
  'microscope': I_Microscope,
  'monitor': I_Monitor,
  'music': I_Music,
  'music-2': I_Music2,
  'navigation': I_Navigation,
  'network': I_Network,
  'newspaper': I_Newspaper,
  'notebook-pen': I_NotebookPen,
  'package': I_Package,
  'package-check': I_PackageCheck,
  'package-open': I_PackageOpen,
  'package-plus': I_PackagePlus,
  'palette': I_Palette,
  'paperclip': I_Paperclip,
  'party-popper': I_PartyPopper,
  'percent': I_Percent,
  'phone': I_Phone,
  'phone-call': I_PhoneCall,
  'pie-chart': I_PieChart,
  'piggy-bank': I_PiggyBank,
  'pill': I_Pill,
  'plane': I_Plane,
  'plane-takeoff': I_PlaneTakeoff,
  'pound-sterling': I_PoundSterling,
  'printer': I_Printer,
  'qr-code': I_QrCode,
  'radio': I_Radio,
  'receipt': I_Receipt,
  'receipt-text': I_ReceiptText,
  'rocket': I_Rocket,
  'route': I_Route,
  'scale': I_Scale,
  'scan-line': I_ScanLine,
  'school': I_School,
  'search': I_Search,
  'send': I_Send,
  'send-horizontal': I_SendHorizontal,
  'server': I_Server,
  'settings': I_Settings,
  'sheet': I_Sheet,
  'shield': I_Shield,
  'shield-check': I_ShieldCheck,
  'ship': I_Ship,
  'shirt': I_Shirt,
  'shopping-bag': I_ShoppingBag,
  'shopping-basket': I_ShoppingBasket,
  'shopping-cart': I_ShoppingCart,
  'signature': I_Signature,
  'sliders': I_Sliders,
  'smartphone': I_Smartphone,
  'sparkles': I_Sparkles,
  'sprout': I_Sprout,
  'star': I_Star,
  'stethoscope': I_Stethoscope,
  'sticky-note': I_StickyNote,
  'store': I_Store,
  'table': I_Table,
  'tag': I_Tag,
  'tags': I_Tags,
  'target': I_Target,
  'thermometer': I_Thermometer,
  'ticket': I_Ticket,
  'ticket-check': I_TicketCheck,
  'ticket-x': I_TicketX,
  'timer': I_Timer,
  'tractor': I_Tractor,
  'train-front': I_TrainFront,
  'trending-down': I_TrendingDown,
  'trending-up': I_TrendingUp,
  'trophy': I_Trophy,
  'truck': I_Truck,
  'tv': I_Tv,
  'undo-2': I_Undo2,
  'unlock': I_Unlock,
  'user': I_User,
  'user-check': I_UserCheck,
  'user-cog': I_UserCog,
  'user-plus': I_UserPlus,
  'user-round': I_UserRound,
  'users': I_Users,
  'users-round': I_UsersRound,
  'utensils': I_Utensils,
  'video': I_Video,
  'wallet': I_Wallet,
  'wand-2': I_Wand2,
  'wand-sparkles': I_WandSparkles,
  'warehouse': I_Warehouse,
  'waypoints': I_Waypoints,
  'wifi': I_Wifi,
  'workflow': I_Workflow,
  'wrench': I_Wrench,
  'zap': I_Zap,
}

/** The picker groups, in authored order. */
export const NAV_ICON_GROUPS: NavIconGroup[] = DATA.groups

/** Every allowed icon name, sorted. */
export const NAV_ICON_NAMES: string[] = Object.keys(MAP).sort()

/** True when `name` is an allow-listed navigation icon. */
export function isNavIcon(name: unknown): name is string {
  return typeof name === 'string' && Object.prototype.hasOwnProperty.call(MAP, name)
}

/** The icon a node shows: its own (when allowed), else its type's, else the default. */
export function navIconName(node: { icon?: string | null; obj_type?: string } | null | undefined): string {
  if (node && isNavIcon(node.icon)) return node.icon
  const byType = node?.obj_type ? DATA.typeFallback[node.obj_type] : undefined
  return byType && MAP[byType] ? byType : DATA.defaultIcon
}

/** The component for a node (or a bare icon name). */
export function navIconComponent(
  node: { icon?: string | null; obj_type?: string } | string | null | undefined,
): LucideIcon {
  const name = typeof node === 'string' ? (isNavIcon(node) ? node : DATA.defaultIcon) : navIconName(node)
  return MAP[name] || MAP[DATA.defaultIcon]
}

export interface NavIconProps {
  node?: { icon?: string | null; obj_type?: string } | null
  /** A bare icon name instead of a node. */
  name?: string
  size?: number
  strokeWidth?: number
  color?: string
  style?: CSSProperties
  className?: string
}

/** Decorative icon for a navigation node — always aria-hidden: the label beside it names the entry. */
export function NavIcon({ node, name, size = 16, strokeWidth = 1.75, color, style, className }: NavIconProps) {
  const Cmp = navIconComponent(name ?? node)
  return <Cmp size={size} strokeWidth={strokeWidth} color={color || 'currentColor'}
              style={{ flexShrink: 0, ...style }} className={className} aria-hidden />
}
